// dmNotify.js — état PARTAGÉ des messages privés non lus (compteur par ami + conversation ouverte).
// Éphémère (mémoire), au niveau module → survit aux remontages. Le DMNotifier (global) l'alimente en
// écoutant les canaux DM ; l'espace membre le lit pour les badges et déclare la conversation ouverte.
let unread = {};        // friendId -> nombre de messages non lus
const openSet = new Set(); // friendIds des conversations actuellement OUVERTES (chat flottant → jusqu'à 3)
let legacyOpen = null;  // slot unique piloté par setOpenWith (espace membre) — pour compat
const subs = new Set();

function emit() { subs.forEach((cb) => { try { cb(); } catch { /* */ } }); }

export function getUnread() { return unread; }
export function unreadFor(fid) { return unread[fid] || 0; }
export function totalUnread() { return Object.values(unread).reduce((a, b) => a + b, 0); }

// Incrémente les non-lus d'un ami (ignoré si sa conversation est ouverte).
export function bumpUnread(fid) { if (!fid || isConversationOpen(fid)) return; unread[fid] = (unread[fid] || 0) + 1; emit(); }
export function clearUnread(fid) { if (fid && unread[fid]) { delete unread[fid]; emit(); } }

// ── PERSISTANCE du « dernier lu » (localStorage) → permet de compter les non-lus arrivés HORS-LIGNE au 1er
// chargement (le compteur ne se limite plus aux MP reçus en direct pendant la session). ──
function readKey(fid) { return 'vg_dm_read_' + fid; }
export function lastReadTs(fid) { try { return parseInt(localStorage.getItem(readKey(fid)) || '0', 10) || 0; } catch { return 0; } }
export function markRead(fid) { if (!fid) return; try { localStorage.setItem(readKey(fid), String(Date.now())); } catch { /* */ } clearUnread(fid); }
// Fixe directement le compteur (chargement initial depuis le serveur).
export function setUnread(fid, n) { if (!fid) return; if (n > 0) unread[fid] = n; else delete unread[fid]; emit(); }

// ── Conversations OUVERTES (plusieurs possibles avec le chat flottant) ──
// Une conversation ouverte = pas de toast, pas d'incrément de non-lus, et marquée lue en continu.
export function isConversationOpen(fid) { return !!fid && (openSet.has(fid) || fid === legacyOpen); }
export function openConversation(fid) { if (!fid) return; openSet.add(fid); markRead(fid); }
export function closeConversation(fid) { if (!fid) return; openSet.delete(fid); }

// Compat espace membre : slot UNIQUE. setOpenWith(fid) ferme le précédent slot puis ouvre le nouveau.
export function setOpenWith(fid) {
  if (legacyOpen && legacyOpen !== fid) closeConversation(legacyOpen);
  legacyOpen = fid || null;
  if (fid) openConversation(fid);
}
export function getOpenWith() { return legacyOpen; }

export function onDmChange(cb) { subs.add(cb); return () => subs.delete(cb); }
export function resetDmNotify() { unread = {}; openSet.clear(); legacyOpen = null; emit(); }
